(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shop-the-look-button').forEach((button) => {
    button.addEventListener('click', () => {
      const popup = button.parentElement.parentElement.querySelector('.shop-the-look-popup');
      if (popup) {
        popup.classList.toggle('active');
      }
    });
  });

  document.querySelectorAll('.shop-the-look-popup-close').forEach((button) => {
    button.addEventListener('click', () => {
      const popup = button.parentElement.parentElement;
      if (popup) {
        popup.classList.toggle('active');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.add-to-cart-btn').forEach((button) => {
      button.addEventListener('click', async function () {
        const card = this.closest('.product-card');
        const variantEl = card.querySelector('.variant-select');
        const variantId = variantEl?.value;

        if (!variantId) {
          console.error('Variant ID missing');
          return;
        }

        this.disabled = true;
        this.innerText = 'Adding...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          });

          if (!res.ok) throw new Error('Add to cart failed');

          await res.json();

          this.innerText = 'Added to Cart';

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

          const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');

          if (cartDrawer) {
            cartDrawer.classList.add('active');

            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }

          const cartIcon = document.querySelector('a[href="/cart"], .header__icon--cart');
          if (cartIcon) {
            cartIcon.click();
          }
        } catch (err) {
          console.error(err);
        }

        setTimeout(() => {
          this.disabled = false;
          this.innerText = 'Add to Cart';
        }, 1500);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
